import { VueConstructor } from "vue/types/vue";
import { Store } from "vuex";
import { TranslateResult } from "vue-i18n";

import SnackbarStore from "./store";
import SnackbarComponent from "./Snackbar.vue";

/// Register types

interface Snackbar {
	openInfo: (text: string | TranslateResult) => void;
	openError: (text: string | TranslateResult) => void;
}

declare module "vue/types/vue" {
	interface Vue {
		$snackbar: Snackbar;
	}
}

export default {
	install(vue: VueConstructor, options: { store: Store<any> }) {
		/// Register stores
		if (!(options && options.store)) {
			throw new Error("Please provide vuex store.");
		}
		options.store.registerModule("snackbar", SnackbarStore);
		
		/// Register components
		vue.component("app-snackbar", SnackbarComponent);

		/// Register methods
		vue.prototype.$snackbar = {
			openInfo: (text: string | TranslateResult) => {
				options.store.dispatch("snackbar/openInfo", text);
			},
			openError: (text: string | TranslateResult) => {
				options.store.dispatch("snackbar/openError", text);
			}
		};
	}
};